import { render, staticRenderFns } from "./NewGsCalendarItem.vue?vue&type=template&id=a2ca353c&scoped=true"
import script from "./NewGsCalendarItem.vue?vue&type=script&lang=js"
export * from "./NewGsCalendarItem.vue?vue&type=script&lang=js"
import style0 from "./NewGsCalendarItem.vue?vue&type=style&index=0&id=a2ca353c&prod&lang=css"
import style1 from "./NewGsCalendarItem.vue?vue&type=style&index=1&id=a2ca353c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2ca353c",
  null
  
)

export default component.exports